import React from 'react';
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Space,
  Row,
  Col,
  Divider,
} from 'antd';
import { MuscleGroup } from '../../types';
import { MUSCLE_GROUP_CATEGORIES } from '../../constants';

const { Option } = Select;

interface MuscleGroupFormProps {
  form: any;
  muscleGroup: MuscleGroup | null;
  onSave: (values: any) => Promise<void>;
  onCancel: () => void;
}

const MuscleGroupForm: React.FC<MuscleGroupFormProps> = ({
  form,
  muscleGroup,
  onSave,
  onCancel,
}) => {
  const handleSubmit = async (values: any) => {
    try {
      await onSave(values);
    } catch (error) {
      console.error('Error saving muscle group:', error);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={muscleGroup || { split: false }}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Muscle Group Name"
            rules={[{ required: true, message: 'Please enter muscle group name' }]}
          >
            <Input placeholder="Enter muscle group name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="category"
            label="Category"
            rules={[{ required: true, message: 'Please select a category' }]}
          >
            <Select placeholder="Select category">
              {Object.values(MUSCLE_GROUP_CATEGORIES).map(category => (
                <Option key={category} value={category}>
                  {category}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      <Form.Item
        name="subCategory"
        label="Sub-category (Optional)"
      >
        <Input placeholder="Enter sub-category (e.g., Arms, Shoulders)" />
      </Form.Item>

      <Form.Item
        name="split"
        label="Bilateral Muscle"
        valuePropName="checked"
      >
        <Switch checkedChildren="L/R" unCheckedChildren="Single" />
      </Form.Item>

      <Divider />

      <Row justify="end">
        <Col>
          <Space>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              {muscleGroup ? 'Update' : 'Create'}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default MuscleGroupForm; 